var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1725.22 388.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clockwork Universe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1203.06,73.65h8l17.06,41.48,17-41.48h8l-20.11,48.1,24,55.64,43.75-104.55h9L1261,187.05h-7.58l-25.08-58.71-25.25,58.71h-7.56L1146.76,72.84h8.84l43.91,104.55,23.64-55.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1393,187.86a47.3,47.3,0,0,1-21.73-5,56,56,0,0,1-16.89-13,58.7,58.7,0,0,1-10.95-18.5,61.67,61.67,0,0,1-3.86-21.4,59.29,59.29,0,0,1,4.1-21.88,61.58,61.58,0,0,1,11.26-18.51,54.55,54.55,0,0,1,17-12.78A48.24,48.24,0,0,1,1393.13,72a47.13,47.13,0,0,1,21.8,5.08,54.91,54.91,0,0,1,16.89,13.27A61.06,61.06,0,0,1,1442.68,109a60.15,60.15,0,0,1-.24,43,60.23,60.23,0,0,1-11.26,18.41,54.49,54.49,0,0,1-17,12.72A48.42,48.42,0,0,1,1393,187.86Zm-45.21-57.92a55.23,55.23,0,0,0,3.29,18.9,51.46,51.46,0,0,0,9.32,16.09,46,46,0,0,0,14.4,11.17,40.42,40.42,0,0,0,18.34,4.19,39.47,39.47,0,0,0,18.59-4.32,46,46,0,0,0,14.16-11.51,55.23,55.23,0,0,0,12.29-34.52,53.68,53.68,0,0,0-3.38-18.88,52.68,52.68,0,0,0-9.4-16.12,46.52,46.52,0,0,0-14.24-11.16,39.13,39.13,0,0,0-18-4.2,39.87,39.87,0,0,0-18.65,4.35,46.38,46.38,0,0,0-14.33,11.51,53.12,53.12,0,0,0-9.17,16.17A54.51,54.51,0,0,0,1347.78,129.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1500.75,187.05V72.84h47.46a29.72,29.72,0,0,1,13.35,3A33.93,33.93,0,0,1,1572.1,84,38.78,38.78,0,0,1,1579,95.44a34.78,34.78,0,0,1,2.49,12.78,38.48,38.48,0,0,1-1.93,12.15,35.27,35.27,0,0,1-5.48,10.53,30.49,30.49,0,0,1-8.52,7.72,29.55,29.55,0,0,1-10.94,4l28.48,44.41h-9.5L1546,144h-37v43.09Zm8.2-50.68H1549a21.25,21.25,0,0,0,10-2.39,25.57,25.57,0,0,0,7.72-6.37,28.13,28.13,0,0,0,4.91-9,32.55,32.55,0,0,0,1.69-10.36,28.56,28.56,0,0,0-2-10.53,29.2,29.2,0,0,0-5.48-8.92,27.4,27.4,0,0,0-8-6.23,21.75,21.75,0,0,0-9.91-2.3H1509Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1638.52,187.05V72.84h8.19v69.33l66.59-69.33h9.49l-47.43,50,49.86,64.18h-9.34L1670,127.87l-23.32,23.95v35.23Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M476.69,129.15a61.3,61.3,0,0,1,3.61-20.52,57.52,57.52,0,0,1,10.54-18.26,54.41,54.41,0,0,1,17-13.11,50.14,50.14,0,0,1,22.93-5.07q15.28,0,26,7a44.16,44.16,0,0,1,16.09,17.94L566.12,101A37.24,37.24,0,0,0,559,91a37.82,37.82,0,0,0-8.84-6.53,38.94,38.94,0,0,0-9.89-3.6,47.67,47.67,0,0,0-10.14-1.16,40.69,40.69,0,0,0-19.31,4.45,45.15,45.15,0,0,0-14.15,11.5,49.79,49.79,0,0,0-8.76,16,56.25,56.25,0,0,0-3,18,53.11,53.11,0,0,0,3.54,19.29,53.67,53.67,0,0,0,9.66,16.17,46.35,46.35,0,0,0,14.47,11.17,39.75,39.75,0,0,0,18,4.2,45.16,45.16,0,0,0,10.62-1.31,40.66,40.66,0,0,0,10.47-4,41.92,41.92,0,0,0,9.31-7,37.2,37.2,0,0,0,7.25-10l7.08,3.35a38,38,0,0,1-7.89,11.44,49.45,49.45,0,0,1-11.09,8.37,52.18,52.18,0,0,1-13,5.06,55.75,55.75,0,0,1-13.44,1.7,45.13,45.13,0,0,1-21.47-5.16,56.88,56.88,0,0,1-16.81-13.43,62.41,62.41,0,0,1-11-18.81A61,61,0,0,1,476.69,129.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M620.55,187.05V72.84h8.21V179.66H697v7.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M776.79,187.86a47.23,47.23,0,0,1-21.72-5,56.06,56.06,0,0,1-16.91-13,58.82,58.82,0,0,1-10.92-18.5,61.22,61.22,0,0,1-3.87-21.4,59.69,59.69,0,0,1,4.09-21.88,61.63,61.63,0,0,1,11.28-18.51,54.4,54.4,0,0,1,17-12.78A48.23,48.23,0,0,1,776.93,72a47,47,0,0,1,21.8,5.08,54.67,54.67,0,0,1,16.89,13.27A61.06,61.06,0,0,1,826.48,109,60.43,60.43,0,0,1,815,170.39a54.61,54.61,0,0,1-17,12.72A48.44,48.44,0,0,1,776.79,187.86Zm-45.21-57.92a55,55,0,0,0,3.29,18.9,50.93,50.93,0,0,0,9.34,16.09,45.61,45.61,0,0,0,14.38,11.17,40.42,40.42,0,0,0,18.34,4.19A39.47,39.47,0,0,0,795.52,176a45.72,45.72,0,0,0,14.16-11.51,54.56,54.56,0,0,0,9.08-16.18,53.9,53.9,0,0,0-.17-37.22,52.48,52.48,0,0,0-9.4-16.12,46.32,46.32,0,0,0-14.25-11.16,39,39,0,0,0-18-4.2,40,40,0,0,0-18.66,4.35A46.3,46.3,0,0,0,744,95.44a53.12,53.12,0,0,0-9.17,16.17A54.51,54.51,0,0,0,731.58,129.94Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M871.34,129.15A61.06,61.06,0,0,1,875,108.63,57.71,57.71,0,0,1,885.5,90.37a54.41,54.41,0,0,1,17-13.11,50.08,50.08,0,0,1,22.93-5.07q15.27,0,26.05,7a44.23,44.23,0,0,1,16.09,17.94L960.79,101a37.54,37.54,0,0,0-16-16.49,38.26,38.26,0,0,0-9.89-3.6,47.34,47.34,0,0,0-10.12-1.16,40.67,40.67,0,0,0-19.31,4.45,45.3,45.3,0,0,0-14.16,11.5,49.79,49.79,0,0,0-8.76,16,56.51,56.51,0,0,0-3,18,53.31,53.31,0,0,0,3.53,19.29,53.88,53.88,0,0,0,9.66,16.17,46.62,46.62,0,0,0,14.48,11.17,39.7,39.7,0,0,0,18,4.2,45.29,45.29,0,0,0,10.62-1.31,40.32,40.32,0,0,0,10.44-4,42,42,0,0,0,9.33-7,37.63,37.63,0,0,0,7.25-10l7.08,3.35a38.39,38.39,0,0,1-7.9,11.44,48.84,48.84,0,0,1-11.1,8.37,51.66,51.66,0,0,1-13,5.06,55.59,55.59,0,0,1-13.42,1.7,45.19,45.19,0,0,1-21.49-5.16,57,57,0,0,1-16.81-13.43,62.17,62.17,0,0,1-11-18.81A61,61,0,0,1,871.34,129.15Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.48,187.05V72.84h8.21v69.33l66.59-69.33h9.48l-47.45,50,49.87,64.18h-9.33L1058,127.87l-23.32,23.95v35.23Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M645.73,308a14.63,14.63,0,0,0,7.54-1.78,14.33,14.33,0,0,0,4.82-4.66,19.88,19.88,0,0,0,2.59-6.56,37.2,37.2,0,0,0,.77-7.58V258.25h9.15v29.16a43.42,43.42,0,0,1-1.38,11.14,25.56,25.56,0,0,1-4.37,9.15,20.89,20.89,0,0,1-7.74,6.2,26.19,26.19,0,0,1-11.38,2.27,25.65,25.65,0,0,1-11.62-2.39,21,21,0,0,1-7.66-6.4,26.48,26.48,0,0,1-4.21-9.19A44.51,44.51,0,0,1,621,287.41V258.25H630v29.16a36.93,36.93,0,0,0,.77,7.66,19.46,19.46,0,0,0,2.59,6.56,13.64,13.64,0,0,0,4.86,4.62A14.87,14.87,0,0,0,645.73,308Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M772.66,275.26v40.5h-9.07V258.25h7.13l32.88,41.48V258.34h9.16v57.42h-7.54Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M906.72,315.76V258.34h9.07v57.42Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.23,258.25l17.42,46.09,17.25-46.09h9.56l-22.92,57.51h-7.78l-23.17-57.51Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.87,307.75v8h-39.44V258.25h38.71v8H1154.5v16.36h25.68v7.54H1154.5v17.58Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.6,315.76V258.25h25a15.93,15.93,0,0,1,7.17,1.62,18.18,18.18,0,0,1,5.63,4.26,19.89,19.89,0,0,1,3.69,6,18.38,18.38,0,0,1,1.33,6.85,19.12,19.12,0,0,1-.81,5.58,19.7,19.7,0,0,1-2.26,4.95,15.89,15.89,0,0,1-3.57,3.92,14.39,14.39,0,0,1-4.61,2.47l13.68,21.87h-10.28l-12.64-20h-13.28v20Zm9.07-28h15.87a7.43,7.43,0,0,0,3.53-.85,8.43,8.43,0,0,0,2.71-2.35,11.8,11.8,0,0,0,1.78-3.44,13.08,13.08,0,0,0,.65-4.13,11.24,11.24,0,0,0-.77-4.14,12,12,0,0,0-2-3.4,9.69,9.69,0,0,0-2.92-2.31,7.57,7.57,0,0,0-3.44-.85h-15.39Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.89,271.78a12.61,12.61,0,0,0-2.35-1.9,23.71,23.71,0,0,0-3.61-1.91,25.53,25.53,0,0,0-4.57-1.45A24.18,24.18,0,0,0,1429,266c-3.56,0-6.27.7-8.1,2.11a7,7,0,0,0-2.75,5.91,6,6,0,0,0,.89,3.44,7.32,7.32,0,0,0,2.67,2.31,22,22,0,0,0,4.45,1.74c1.79.51,3.86,1.07,6.24,1.66q4.21,1.14,7.74,2.35a22.12,22.12,0,0,1,6,3A12.78,12.78,0,0,1,1450,293a14.42,14.42,0,0,1,1.38,6.65,16.09,16.09,0,0,1-1.7,7.69,14.47,14.47,0,0,1-4.58,5.14,20,20,0,0,1-6.68,2.92,34.07,34.07,0,0,1-8.1.93,41.25,41.25,0,0,1-12.72-2,36.25,36.25,0,0,1-11.1-5.79l4.21-7.78a19.63,19.63,0,0,0,3,2.35,27.11,27.11,0,0,0,4.58,2.39,38.59,38.59,0,0,0,5.79,1.86,27.72,27.72,0,0,0,6.56.77c3.46,0,6.14-.63,8.06-1.9a6.23,6.23,0,0,0,2.87-5.55,6.11,6.11,0,0,0-1-3.65,9,9,0,0,0-3.08-2.55,25.44,25.44,0,0,0-4.94-1.94c-1.94-.57-4.16-1.18-6.64-1.82a71.15,71.15,0,0,1-7.49-2.39,18.79,18.79,0,0,1-5.31-3,12,12,0,0,1-3.2-4.17,13.88,13.88,0,0,1-1.09-5.79,17.14,17.14,0,0,1,1.58-7.5,15.58,15.58,0,0,1,4.37-5.5,19.3,19.3,0,0,1,6.61-3.37,28.67,28.67,0,0,1,8.18-1.13,30.5,30.5,0,0,1,10.89,1.86,35.74,35.74,0,0,1,8.63,4.62Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1581,307.75v8h-39.45V258.25h38.72v8h-29.65v16.36h25.68v7.54h-25.68v17.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.74,218.71a88.09,88.09,0,0,1-50-76.64c0-.94-.07-1.88-.07-2.83,0-.4,0-.8,0-1.21,1.61,1.34,3.29,2.61,5,3.83a86.1,86.1,0,0,0,36,15h0a89.1,89.1,0,0,0,8.87,1c1.81.1,3.62.18,5.45.18a86.37,86.37,0,0,0,64.64-29,131.6,131.6,0,0,1,16.9,64.68,133,133,0,0,1-1.48,19.77,88,88,0,0,1-79.87,7.61c-1.86-.75-3.7-1.53-5.5-2.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,205.49c-.32-3.88-.52-7.8-.52-11.77A142.58,142.58,0,0,1,159.68,55.37a86.34,86.34,0,0,1,20.44-41.6C86.74,20.9,13.18,98.87,13.18,194.06c0,4.72.24,9.39.6,14A122.49,122.49,0,0,1,41.05,205C44.75,205,48.41,205.17,52,205.49ZM29.76,145.15a9.79,9.79,0,1,1,9.79,9.79A9.79,9.79,0,0,1,29.76,145.15Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.61,322.37A142.94,142.94,0,0,1,58.22,237a91.78,91.78,0,0,0-39.6,1.14A181.22,181.22,0,0,0,126,361.64a91.37,91.37,0,0,0,6.77-34.57C132.73,325.49,132.69,323.93,132.61,322.37Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.06,245.6h0a51.7,51.7,0,0,1-24.73-6.27q-2.21-1.2-4.27-2.6a51.89,51.89,0,0,1,0-86q2.07-1.39,4.27-2.6a51.36,51.36,0,0,1,20.19-6c0-.94-.07-1.88-.07-2.83,0-.41,0-.8,0-1.21-.69-.57-1.35-1.16-2-1.75A57.82,57.82,0,1,0,245,221.1c-1.86-.75-3.7-1.53-5.5-2.39A51.85,51.85,0,0,1,194.06,245.6Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.35,
    cy: 121.68,
    r: 12.62,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.45,258.17a12.63,12.63,0,1,0,12.62,12.63A12.62,12.62,0,0,0,252.45,258.17Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.51,218.71a88.07,88.07,0,0,1-50-76.64,51.52,51.52,0,0,0-20.19,6q-2.21,1.2-4.27,2.6a51.89,51.89,0,0,0,0,86q2.07,1.4,4.27,2.6a51.87,51.87,0,0,0,70.18-20.62Z",
    style: {
      fill: "#2463af",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821300029754639px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.34,233.73a9.79,9.79,0,1,0,9.79,9.8A9.8,9.8,0,0,0,348.34,233.73Z",
    style: {
      fill: "#2463af",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821300029754639px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.33,145.15a9.79,9.79,0,1,0-9.78,9.79A9.78,9.78,0,0,0,49.33,145.15Z",
    style: {
      fill: "#2463af",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821300029754639px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,54.36a58.49,58.49,0,0,0-3.39-8.53A179.76,179.76,0,0,0,225.47,16a58.76,58.76,0,0,0-35.79,35.32c1.46-.05,2.91-.12,4.38-.12A142.36,142.36,0,0,1,298,96.2a58.4,58.4,0,0,0,3-41.84Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.53,136.51a180.52,180.52,0,0,0-34.22-60.19,86.12,86.12,0,0,1-15,44,141.89,141.89,0,0,1,20.32,73.39c0,3.78-.19,7.53-.48,11.25A142.47,142.47,0,0,1,163,332.83a121.33,121.33,0,0,1-7.91,37.85A180.85,180.85,0,0,0,365.53,136.51Zm-17.19,116.8a9.79,9.79,0,1,1,9.79-9.78A9.78,9.78,0,0,1,348.34,253.31Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6,66a88.44,88.44,0,0,0-32.12,38.72,58.66,58.66,0,0,0,96.11.74A132.27,132.27,0,0,0,228.6,66Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.15,240.12A92.81,92.81,0,0,0,58.22,237a142.94,142.94,0,0,0,74.39,85.36,93.51,93.51,0,0,0-1.47-12.26A132.71,132.71,0,0,1,70.15,240.12Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.77,193.72A132.33,132.33,0,0,1,158.33,66.34a85.84,85.84,0,0,1,1.35-11A142.57,142.57,0,0,0,51.51,193.71c0,4,.2,7.9.52,11.78,3.51.32,7,.79,10.39,1.39C62,202.56,61.77,198.16,61.77,193.72Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,59.1a142.28,142.28,0,0,0-46.92-7.94c-1.47,0-2.92.07-4.38.12A58.11,58.11,0,0,0,187,61.61c2.36-.12,4.73-.19,7.11-.19a132.09,132.09,0,0,1,98.53,44.05A59.07,59.07,0,0,0,298,96.2,142.7,142.7,0,0,0,241,59.1Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.29,120.33a88.76,88.76,0,0,1-6.83,8.71A132.28,132.28,0,0,1,163,322.31c.05,1.58.12,3.15.12,4.76,0,1.93-.06,3.85-.15,5.76A142.47,142.47,0,0,0,336.13,205c.29-3.71.48-7.46.48-11.25A141.89,141.89,0,0,0,316.29,120.33Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.86,59.46a181.3,181.3,0,0,0-17.21-13.63A58.71,58.71,0,1,1,186.08,71.37a59.23,59.23,0,0,1,.87-9.76,58.11,58.11,0,0,1,2.73-10.33A58.76,58.76,0,0,1,225.47,16a181.64,181.64,0,0,0-31.41-2.77c-4.7,0-9.34.23-13.95.58a86.77,86.77,0,0,0-21.78,52.57c-.09,1.67-.16,3.34-.16,5a86.41,86.41,0,0,0,29.29,64.91c.67.59,1.33,1.18,2,1.75,1.61,1.35,3.28,2.61,5,3.84a86.24,86.24,0,0,0,36,14.94h0a83.36,83.36,0,0,0,8.86,1c1.81.12,3.62.19,5.45.19a86.43,86.43,0,0,0,64.65-29,88.63,88.63,0,0,0,6.83-8.7,86.38,86.38,0,0,0,15-44A181.82,181.82,0,0,0,314.86,59.46Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821300029754639px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,322.31A122.07,122.07,0,0,0,62.42,206.89Q57.29,206,52,205.49c-3.62-.32-7.28-.51-11-.51a122.49,122.49,0,0,0-27.27,3.1,179.43,179.43,0,0,0,4.84,30.07A91.78,91.78,0,0,1,58.22,237a92.81,92.81,0,0,1,11.93,3.11,91.8,91.8,0,0,1,62.46,82.25c.08,1.56.12,3.12.12,4.7A91.37,91.37,0,0,1,126,361.64a178.76,178.76,0,0,0,29.11,9A121.33,121.33,0,0,0,163,332.83c.09-1.91.15-3.83.15-5.76C163.13,325.46,163.06,323.89,163,322.31Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821799993515015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.15,240.12a132.71,132.71,0,0,0,61,70A91.8,91.8,0,0,0,70.15,240.12Z",
    style: {
      fill: "#004173",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821300029754639px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,221.1a57.83,57.83,0,1,1-57.55-84.82,86.4,86.4,0,0,1-29.28-64.91c0-1.69.06-3.36.15-5A132.33,132.33,0,0,0,61.77,193.72c0,4.44.23,8.84.65,13.17A122.07,122.07,0,0,1,163,322.31,132.29,132.29,0,0,0,324.88,213.48,88.08,88.08,0,0,1,245,221.1ZM118.72,121.68a12.63,12.63,0,1,1,12.63,12.62A12.64,12.64,0,0,1,118.72,121.68ZM252.45,283.43a12.63,12.63,0,1,1,12.62-12.63A12.62,12.62,0,0,1,252.45,283.43Z",
    style: {
      fill: "#004173",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821300029754639px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.48,104.72A88.38,88.38,0,0,1,228.6,66a132.46,132.46,0,0,0-34.54-4.58c-2.38,0-4.75.07-7.11.19a59.23,59.23,0,0,0-.87,9.76A58.48,58.48,0,0,0,196.48,104.72Z",
    style: {
      fill: "#004173",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821300029754639px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.13,56.3A193,193,0,0,0,195.1.43l-1,0C87.11.41.41,87.11.41,194.06c0,5.94.31,11.8.83,17.59A193.7,193.7,0,0,0,194.06,387.72c107,0,193.66-86.71,193.66-193.66A193.09,193.09,0,0,0,330.13,56.3ZM194.06,374.94a180.84,180.84,0,0,1-39-4.27,178.73,178.73,0,0,1-29.11-9A181.24,181.24,0,0,1,18.62,238.15a179.38,179.38,0,0,1-4.84-30.08c-.36-4.62-.6-9.29-.6-14,0-95.2,73.56-173.16,166.94-180.29,4.6-.35,9.24-.58,13.94-.58A181.64,181.64,0,0,1,225.47,16a180.86,180.86,0,0,1-31.41,359Z",
    style: {
      fill: "#004173",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.821300029754639px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCw);
export default __webpack_public_path__ + "static/media/logo-cw.373d4b9d27ebf119210d32c3ca7807aa.svg";
export { ForwardRef as ReactComponent };